export default class IncentiveProgramEditPM {
  incentiveProgramId: number | null = null;
  comment = "";
  registrationId = 0;
  registrationRowVersion = "";
}